export const PAGINATION_MANUAL_TEMPLATE = `
    <span style="margin:0 6px">
        <span>{{$parent.beforePageText}}</span>
        <input
            class="pagination-num"
            type="text" 
            v-model="value"
            size="2"
            @blur="onBlur()"
            @keydown="onKeyDown($event)"
        />
        <span>{{$parent.afterPageInfo}}</span>
    </span>
`;

export default {
    name: 'PaginationManual',
    template: PAGINATION_MANUAL_TEMPLATE,
    props: {
        pageNumber: Number
    },
    data() {
        return {
            value: this.pageNumber
        }
    },
    watch: {
        pageNumber() {
            this.value = this.pageNumber;
        }
    },
    methods: {
        onBlur() {
            const page = parseInt(this.value, 10) || 1;
            this.value = page;
            this.$emit('pageInput', page);
        },
        onKeyDown(event) {
            if (event.keyCode === 13) {
                this.onBlur()
            }
        }
    }
}